import { PlugCharging } from "@phosphor-icons/react";

// Single source for the Emporia Pro spec card — shown in the FAQ accordion and
// in the expandable perk card on the 1425 NE 24th St property pages.
const EV_SPECS = [
  ["Charger", "Emporia Pro — Level 2, hardwired"],
  ["Power", "Up to 11.5 kW — roughly 30–40 miles of range per hour"],
  ["Plug", "J1772, the universal standard — and we provide the NACS adapter for Tesla drivers, so every EV plugs straight in"],
  ["Cable", "25 ft — reaches every parking space by the homes"],
  ["Cost", "Free for guests, for your whole stay"],
  ["Where", "On-site at 1425 NE 24th St, Wilton Manors"],
];

export const EvChargerDetails = () => (
  <div className="rounded-2xl border border-amber-400/50 bg-amber-400/5 p-6 md:p-7">
    <div className="flex items-center gap-3 mb-5">
      <span className="w-9 h-9 rounded-full bg-amber-400/20 grid place-items-center shrink-0">
        <PlugCharging size={20} weight="fill" className="text-amber-500" />
      </span>
      <p className="font-display text-xl text-emerald">The charger, in detail</p>
    </div>
    <dl className="space-y-3.5" data-testid="faq-ev-specs">
      {EV_SPECS.map(([k, v]) => (
        <div key={k} className="flex gap-4 border-b border-emerald/10 pb-3.5 last:border-0 last:pb-0" data-testid={`faq-ev-spec-${k.toLowerCase()}`}>
          <dt className="w-20 shrink-0 text-xs uppercase tracking-wider text-emerald-soft pt-0.5">{k}</dt>
          <dd className="text-emerald font-light leading-relaxed">{v}</dd>
        </div>
      ))}
    </dl>
  </div>
);

export default EvChargerDetails;
